<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='120px' :model='queryInfo'>
        <div class='searchBox'>
          <div class='content'>
            <el-row>
              <el-col :span='8'>
                <el-form-item label='机构：'>
                  <el-select style='width: 100%' v-model='queryInfo.orgId' placeholder='请选择机构'>
                    <el-option v-for='item in selectData' :key='item.id' :label='item.statName' :value='item.id'>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='8' style="margin-left:30px">
                <el-button type='primary' @click='querySearch' class='searchBtns'>查询
                </el-button>
                <el-button type="info" icon="el-icon-delete" @click="resert" style="margin-left:10px">清除条件
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </global-tag>
    <div class='table_title'>
      <div class='btn_group'>
        <el-button type='success' class='button openBtns' @click="handleTableForm('新增', 'add')">新增
        </el-button>
      </div>
    </div>
    <!-- tableb表格 -->
    <div class='table_container'>
      <el-table :data='tableData' tooltip-effect='dark' style='width: 100%' height='550px'
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }" border>
        <el-table-column type='index' width='70' label='序号' align='center' v-if="
          this.tempTableChekbox.findIndex(
            (item) => item == '序号'
          ) != -1
        " :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label='机构' align='center' prop='orgName' :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label='任务类型' align='center' prop='taskType' :show-overflow-tooltip='true'>
          <template slot-scope='scope'>
            <span v-if="scope.row.taskType == '1'">次数</span>
            <span v-if="scope.row.taskType == '2'">时长</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop='taskCount' :show-overflow-tooltip='true'>
          <template slot="header">
            <span>{{ dynamicHeader }}</span>
          </template>
        </el-table-column>
        <el-table-column label='操作' align='center' width='200px' fixed='right' v-if="
          this.tempTableChekbox.findIndex(
            (item) => item == '操作'
          ) != -1
        ">
          <template slot-scope='scope'>
            <span @click="handleTableForm('详情', scope.row)" style='margin-right: 12px; cursor: pointer'>查看</span>
            <span @click="handleTableForm('编辑', scope.row)" style='margin-right: 12px; cursor: pointer'>编辑</span>
            <span @click='deleteItem(scope.row)' style='margin-right: 12px; cursor: pointer'>删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container'>
      <el-pagination :page-size='pageOne.pageSize' :current-page.sync='pageOne.pageNo'
        layout='total, sizes, prev, pager, next, jumper' :total='pageOne.total' @size-change='handletableDataSize'
        @current-change='handleTableDataChange'></el-pagination>
    </div>
    <addTask v-if='addressSate' :openData='addressInfo' :orgList="selectData" @cancleAddress='cancleAddress'></addTask>
  </div>
</template>
<script>
import addTask from './components/addTask.vue'

export default {
  inject: ['reload'], //注入
  components: { addTask },
  data() {
    return {
      addressSate: false,
      selectData: [
      ],
      addressInfo: {},
      queryInfo: { title: '', relevantTags: '' },
      pageOne: { pageSize: 10, pageNo: 1, total: 0 },
      tableData: [],
      dialogVisible: false, //人员编辑
      dialogInfo: {},
      personState: false, //新增人员
      personInfo: {},
      radioId: '',
      tempTableChekbox: [
        '序号',
        '机构',
        '任务类型',
        '次数',
        '操作'
      ],
      tableChekbox: [
        '序号',
        '机构',
        '任务类型',
        '次数',
        '操作'
      ]
    }
  },
  computed: {
    dynamicHeader() {
      // 如果表格数据中所有行的taskType相同，可以根据第一行判断
      if (this.tableData && this.tableData.length > 0) {
        return this.tableData[0].taskType == '1' ? '次数' : '时长';
      }
      return '次数/时长'; // 默认值
    }
  },
  created() {
    this.getOrgList()
    this.getList()
  },
  methods: {
    cancleAddress(data) {
      this.addressSate = false
      if (data == true) {
        this.getList()
      }
    },
    // 搜索
    querySearch() {
      this.getList()
    },
    resert(){
       this.queryInfo={}
       this.getList()
    },
    cancleOpen() {
      this.dialogInfo = {}
      this.dialogVisible = false
      // this.tableData = [];
      this.getList()
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id
      }
      this.$confirm('确认永久删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .request({
            url: '/jjyl/admin/task/config/delete?id=' + date.id,
            method: 'DELETE',
            data: {}
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              // this.tableData = [];
              this.getList()
            }
          })
      })
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //重置
    clearData() {
      this.reload()
    },
    //获取机构信息
    getOrgList() {
      this.$http
        .request({
          url: '/jjyl/admin/task/state/getServiceStationList',
          method: 'POST',
          data: {}
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              this.selectData = []
              return
            }
            this.selectData = res.content
          }
        })
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        orgId: this.queryInfo.orgId
      }
      this.$http
        .request({
          url: '/jjyl/admin/task/config/list',
          method: 'POST',
          data: params
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    // 操作方法
    handleTableForm(title, row) {
      this.addressInfo = {
        title: title,
        id: title == '新增' ? '' : row.id,
        state: true
      }
      this.addressSate = true
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .table_title {
  margin-top: 20px !important;
}

.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
